<div class="modal-header">
  <h1>{{ title | titlecase }}</h1>
  <i class="uil uil-times" (click)="close()"></i>
</div>
